import React from 'react';

export function ArtistCardSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton skeleton-image" />
      <div className="skeleton skeleton-text" />
      <div className="skeleton skeleton-text-sm" />
    </div>
  );
}

export function TrackSkeleton() {
  return (
    <div className="track-item" style={{ opacity: 0.5 }}>
      <div className="skeleton" style={{ width: 32, height: 20 }} />
      <div className="skeleton" style={{ flex: 1, height: 20 }} />
      <div className="skeleton" style={{ width: 80, height: 28 }} />
    </div>
  );
}

export function ReleaseCardSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton skeleton-image" />
      <div className="skeleton skeleton-text" />
      <div className="skeleton skeleton-text-sm" />
    </div>
  );
}
